import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import './css/Counters.css'

export default class Counters extends Component {
        render() {
                return (
                        <Container id="counters-container" className="w-100">
                                <Row>
                                        <Col lg={3} md={6} sm={12} align="center">
                                                <div className="counter-card">
                                                        <Row>
                                                                <Col lg={12} className="text-center p-0 m-0">
                                                                        <p className="counter-text">PROCCESSED <br></br> DATASETS</p>
                                                                </Col>
                                                                <Col lg={12} className="text-center p-0 m-0">
                                                                        <p className="counter-number">000,000</p>
                                                                </Col>
                                                                <Col lg={12} >
                                                                        <img height="45" src="/images/HomePage/processing.png" alt="reivew"></img>
                                                                </Col>
                                                        </Row>
                                                </div>
                                        </Col>
                                        <Col lg={3} md={6} sm={12} align="center">
                                                <div className="counter-card">
                                                        <Row>
                                                                <Col lg={12} className="text-center">
                                                                        <p className="counter-text">DATA <br></br> SCIENTISTS</p>
                                                                </Col>
                                                                <Col lg={12} className="text-center">
                                                                        <p className="counter-number">000,000</p>
                                                                </Col>
                                                                <Col lg={12} >
                                                                        <img height="50" src="/images/HomePage/scientist.png" alt="reivew"></img>
                                                                </Col>
                                                        </Row>
                                                </div>
                                        </Col>
                                        <Col lg={3} md={6} sm={12} align="center">
                                                <div className="counter-card">
                                                        <Row>
                                                                <Col lg={12} className="text-center">
                                                                        <p className="counter-text">REPORTS <br></br> GENERATED</p>
                                                                </Col>
                                                                <Col lg={12} className="text-center">
                                                                        <p className="counter-number">000,000</p>
                                                                </Col>
                                                                <Col lg={12} >
                                                                        <img height="45" src="/images/HomePage/report.png" alt="reivew"></img>
                                                                </Col>
                                                        </Row>
                                                </div>
                                        </Col>
                                        <Col lg={3} md={6} sm={12} align="center">
                                                <div className="counter-card">
                                                        <Row>
                                                                <Col lg={12} className="text-center">
                                                                        <p className="counter-text">POSITIVE <br></br> REVIEWS</p>
                                                                </Col>
                                                                <Col lg={12} className="text-center">
                                                                        <p className="counter-number">000,000</p>
                                                                </Col>
                                                                <Col lg={12} >
                                                                        <img height="45" src="/images/HomePage/review.png" alt="reivew"></img>
                                                                </Col>
                                                        </Row>
                                                </div>
                                        </Col>
                                </Row>
                        </Container>
                )
        }
}
